<template>
  <div v-bind:class="{ 'form-group': true, 'has-error': this.m_error !== null }">
    <label>{{ field.label }}</label>
    <the-mask
      :mask="['##.###.###/####-##']"
      type="text"
      :masked="true"
      placeholder="Informe o CNPJ"
      class="form-control"
      v-model="m_fieldAnswer.value"
      :disabled="disabledAttribute"
    />
  </div>
</template>

<script>
  import TheMask from 'vue-the-mask'

  export default {
    props: ['field', 'fieldAnswer', 'isDisabled'],
    name: 'CNPJField',
    components: { TheMask },
    data () {
      return {
        m_fieldAnswer: {
          fieldUuid: this.field.uuid,
          value: this.fieldAnswer.value
        },
        m_error: null,
        m_rowIndex: this.fieldAnswer.rowIndex
      }
    },
    watch: {
      'm_fieldAnswer.value' () {
        this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer)
      }
    },
    computed: {
      disabledAttribute () {
        return this.field.disabled === true || this.isDisabled === true
      }
    },
    methods: {
      isValid () {
        if (
          (this.field.required && !this.m_fieldAnswer.value) ||
          (this.m_fieldAnswer.value && !this.validateCNPJ(this.m_fieldAnswer.value))
        ) {
          this.m_error = true
          return false
        }

        this.m_error = null
        return true
      },
      validateCNPJ (value) {
        value = value.replace(/[^\d]+/g, '')

        if (value.length !== 14) {
          return false
        }

        // Elimina CNPJs invalidos conhecidos
        if (value === '00000000000000' ||
          value === '11111111111111' ||
          value === '22222222222222' ||
          value === '33333333333333' ||
          value === '44444444444444' ||
          value === '55555555555555' ||
          value === '66666666666666' ||
          value === '77777777777777' ||
          value === '88888888888888' ||
          value === '99999999999999') {
          return false
        }

        // Valida DVs
        let tamanho = value.length - 2
        let numeros = value.substring(0, tamanho)
        let digitos = value.substring(tamanho)
        let soma = 0
        let pos = tamanho - 7
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--
          if (pos < 2) {
            pos = 9
          }
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
        if (parseFloat(resultado) !== parseFloat(digitos.charAt(0))) {
          return false
        }

        tamanho = tamanho + 1
        numeros = value.substring(0, tamanho)
        soma = 0
        pos = tamanho - 7
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--
          if (pos < 2) {
            pos = 9
          }
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
        if (parseFloat(resultado) !== parseFloat(digitos.charAt(1))) {
          return false
        }
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CNPJField.vue?51c7dbb0